var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CoHtml',{staticClass:"co-editor-content",attrs:{"html":_vm.normalizedContent}})}
var staticRenderFns = []

export { render, staticRenderFns }